import { render } from "./AncestryNeatherLand.vue?vue&type=template&id=0894324c"
import script from "./AncestryNeatherLand.vue?vue&type=script&lang=js"
export * from "./AncestryNeatherLand.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__